<style>
  .loadWrapper {
    background: rgba(0,0,0,0.3);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1049;
  }
</style>
<div class="loadWrapper" *ngIf="loader">
  <div class="app-loader flex-column align-items-center">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
    <div *ngIf="loadingWorkflow === true">Estamos a iniciar o seu pedido. Esta operação poderá demorar alguns segundos. Por favor aguarde.</div>
    <div *ngIf="loadingPM === true">Esta operação poderá demorar alguns segundos. Por favor aguarde.</div>
  </div>
</div>
